import React from 'react';
import PropTypes from 'prop-types';

import Accordion from './Accordion';
import Tabs from './Tabs';
import CrestComparisonChart from './CrestComparisonChart';
import { reconcileSectionComponent } from '../utils/sections';

export default class ProductSections extends React.Component {
  static propTypes = {
    productSlug: PropTypes.string,
    sections: PropTypes.arrayOf(
      PropTypes.shape({
        data: PropTypes.object,
        id: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired
      })
    ).isRequired,
    show: PropTypes.string
  };

  get sections() {
    return this.props.sections.map(section => ({
      ...section,
      view:
        section.id === 'custom'
          ? () => <div>{section.data}</div>
          : props => {
            const View = reconcileSectionComponent(section.id);
            if (
              (this.props.productSlug === 'crest-condensing-boiler' ||
                this.props.productSlug ===
                  'crest-with-hellcat-combustion-technology') && section.id === 'lit'
            ) {
              return (
                <div>
                  <CrestComparisonChart slug={this.props.productSlug} />
                  <View {...props} />
                </div>
              );
            }

            return <View {...props} />;
          }
    }));
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.listener);
  }

  shouldComponentUpdate(nextProps) {
    return nextProps.show !== this.props.show;
  }

  render() {
    const { show } = this.props;

    return (
      <React.Fragment>
        {show === 'tabs' && (
          <Tabs
            offset="133px"
            productSlug={this.props.productSlug}
            sections={this.sections}
          />
        )}
        {show === 'accordion' && <Accordion sections={this.sections} />}
      </React.Fragment>
    );
  }
}
